// @flow
import types from './supplierConstants';

const INIT_STATE = {
    supplierList: [],
    listLoaded: false,
    pendingIds: [],
    supplier: {},
    notFound: false,
    loading: false,
    success: null,
    error: null
};

const Supplier = (state = INIT_STATE, action) => {
    switch (action.type) {
        case types.CLEAR_STATE:
            return {
                ...INIT_STATE
            }
        //List
        case types.GET_SUPPLIERS:
            return {
                ...state,
                loading: true
            };
        case types.GET_SUPPLIERS_SUCCESS:

            return {
                ...state,
                supplierList: action.payload.data.items,
                listLoaded: true,
                loading: false,
                error: null
            };
        case types.GET_SUPPLIERS_FAILED:
            return {
                ...state,
                error: action.payload,
                listLoaded: true,
                loading: false
            };
        //List

        //Change Status (optimistic)
        case types.PATCH_SUPPLIER_STATUS: {
            const { id, isActive } = action.payload;
            return {
                ...state,
                supplierList: (state.supplierList || []).map(item => (item.id === id ? { ...item, isActive } : item)),
                pendingIds: [...(state.pendingIds || []).filter(x => x !== id), id],
                success: null
            };
        }
        case types.PATCH_SUPPLIER_STATUS_SUCCESS:
            return {
                ...state,
                pendingIds: (state.pendingIds || []).filter(x => x !== action.payload.id),
                success: 'SUPPLIER.STATUS.UPDATE.SUCESS',
                error: null
            };
        case types.PATCH_SUPPLIER_STATUS_FAILED: {
            const { id, isActive, error } = action.payload;
            return {
                ...state,
                supplierList: (state.supplierList || []).map(item => (item.id === id ? { ...item, isActive } : item)),
                pendingIds: (state.pendingIds || []).filter(x => x !== id),
                error,
                success: null
            };
        }
        //Change Status

        //supplier
        case types.GET_SUPPLIER:
            return {
                ...state,
                notFound: false,
                loading: true
            };
        case types.GET_SUPPLIER_SUCCESS: {
            // GET /suppliers/{id} answers 200 with an empty body for an unknown id.
            const found = !!(action.payload.data && action.payload.data.id > 0);
            return {
                ...state,
                supplier: found ? action.payload.data : {},
                notFound: !found,
                loading: false,
                error: null
            };
        }
        case types.GET_SUPPLIER_FAILED:
            return {
                ...state,
                error: action.payload,
                notFound: true,
                loading: false
            };

        case types.POST_SUPPLIER:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.POST_SUPPLIER_SUCCESS:
            return {
                ...state,
                success: 'SUPPLIER.CREATED.SUCESS',
                loading: false,
                error: null
            };
        case types.POST_SUPPLIER_FAILED:
            return {
                ...state,
                success: null,
                error: action.payload,
                loading: false
            };
        case types.PATCH_SUPPLIER:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.PATCH_SUPPLIER_SUCCESS:
            return {
                ...state,
                success: 'SUPPLIER.UPDATED.SUCESS',
                loading: false,
                error: null
            };
        case types.PATCH_SUPPLIER_FAILED:
            return {
                ...state,
                success: null,
                error: action.payload,
                loading: false
            };
        //supplier

        default:
            return state;
    }
};

export default Supplier;
